import { render, staticRenderFns } from "./DownloadCatalog.vue?vue&type=template&id=54162a86&scoped=true"
import script from "./DownloadCatalog.vue?vue&type=script&lang=js"
export * from "./DownloadCatalog.vue?vue&type=script&lang=js"
import style0 from "./DownloadCatalog.vue?vue&type=style&index=0&id=54162a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54162a86",
  null
  
)

export default component.exports